import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import {
	Auction,
	AuctionQueryParams,
	AUCTION_STATUS,
	AUCTION_BID_INCREMENT_TYPE,
	Bid,
	BidQueryParams,
	AuctionFormSubmit
} from "../types";

interface AuctionState {
	auctions: Array<Auction>;
	auctionsTotal: number;
	auction: Auction;
	bids: Bid[];
	bidsTotal: number

}

export const auctionDefault: Auction = {
	car: { id: 0, name: "", cover: "" },
	merchant: { id: 0, fullName: "" },
	merchantRequestId: null,
	status: AUCTION_STATUS.CANCELED,
	startDate: "",
	endDate: "",
	actualEndDate: "",
	startingPrice: 0,
	expectPrice: 0,
	updatedBy: 0,
	currentBidding: 0,
	bidIncrementType: AUCTION_BID_INCREMENT_TYPE.FIXED,
	bidIncrement: 0,
	note: "",
};

const initialState: AuctionState = {
	auctions: [],
	auctionsTotal: 0,
	auction: auctionDefault,
	bids: [],
	bidsTotal: 0
};

export const auctionSlice = createSlice({
	name: "auction",
	initialState,
	reducers: {
		setAuctions: (state, action) => {
			state.auctions = action.payload.data;
			state.auctionsTotal = action.payload.total;
		},
		setAuction: (state, action) => {
			state.auction = action.payload;
		},
		changeStatusAuction: (state, action) => {
			const { id, status } = action.payload;
			const index = state.auctions.findIndex(el => el.id === id);
			state.auctions[index].status = status;
		},
		setBids: (state, action) => {
			state.bids = action.payload.data;
			state.bidsTotal = action.payload.total
		},
	},
});

export const selectAuctions = (state: RootState) => state.auction.auctions;
export const selectAuctionsTotal = (state: RootState) =>
	state.auction.auctionsTotal;
export const selectAuction = (state: RootState) => state.auction.auction;
export const selectBids = (state: RootState) => state.auction.bids;
export const selectBidsTotal = (state: RootState) => state.auction.bidsTotal;

export const { setAuctions, setAuction, changeStatusAuction, setBids } =
	auctionSlice.actions;

export interface GetAuctionsAsyncPayload {
	query: AuctionQueryParams;
	callback?: () => void;
}
export interface GetAuctionDetailsPayload {
	id: number | string;
	callback?: () => void;
}
export interface CreateAuctionPayload {
	data: AuctionFormSubmit;
	callback: (isOk: boolean) => void;
}
export interface UpdateAuctionPayload {
	id: number | string;
	data: AuctionFormSubmit;
	callback?: () => void;
}

export interface GetBidsPayload {
	id: number | string;
	query: BidQueryParams;
}

export const getAuctionsAsync = createAction(
	"auction/getAuctions",
	(payload: GetAuctionsAsyncPayload) => ({
		payload: payload || {},
	}),
);

export const getAuctionDetailsAsync = createAction(
	"auction/getAuctionDetails",
	(payload: GetAuctionDetailsPayload) => ({
		payload: payload,
	}),
);

export const createNewAuctionAsync = createAction(
	"auction/createNewAuction",
	(payload: CreateAuctionPayload) => ({
		payload: payload,
	}),
);

export const updateAuctionAsync = createAction(
	"auction/updateAuction",
	(payload: UpdateAuctionPayload) => ({
		payload: payload,
	}),
);

export const getBidsAsync = createAction(
	"auction/getBidsAsync",
	(payload: GetBidsPayload) => ({
		payload: payload,
	}),
);


export default auctionSlice.reducer;
